import type { AnalyticsService } from '@/shared/features/analytics/application/services/AnalyticsService';
import type { PosCartItem } from '@/features/posCart/domain/models/PosCartItem';
import { getPosCartCount } from '@/features/posCart/utils/posCartUtils';

export const USER_CONTEXT_LOADED = 'User Data Loaded';

export function trackUserContextLoaded(analytics: AnalyticsService, items: PosCartItem[]): void {
  analytics.trackEvent(USER_CONTEXT_LOADED, {
    'POS Cart Count': getPosCartCount(items),
  }, { eventProviders: ['webengage'] });
}
